import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { WoundCareWidgetComponent } from '../wound-care-widget/wound-care-widget.component';

@Component({
  selector: 'app-wound-derm-sidebar',
  templateUrl: './wound-derm-sidebar.component.html',
  styleUrls: ['./wound-derm-sidebar.component.css']
})
export class WoundDermSidebarComponent implements OnInit {
  @Input() provider;
  @Input() note;
  @Input() patient;
  @Input() isDermAllowed;
  @Input() woundStateCounts: any;
  @Input() readOnlyMode: any;

  @Output() onICDsSave: EventEmitter<any> = new EventEmitter();
  @Output() woundDetailsChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(WoundCareWidgetComponent) skinwoundCareComponent: WoundCareWidgetComponent;
  constructor() { }

  ngOnInit(): void {
  }
  updateWoundfromNote(id, data){
    this.skinwoundCareComponent.updateWoundfromNote(id, data);
  }
  handleWoundDetailsChange($event){
    this.woundDetailsChange.emit($event);
  }
}
